import { message } from 'components';
import { useUpdateContactNoteMutation } from 'services';
import { ContactDto, UpdateContactDto } from 'types';
export function useUpdateContactNote(contactId: number) {
  const [onUpdate, { isLoading }] = useUpdateContactNoteMutation();
  const onUpdateContactHandle = (
    values: Omit<UpdateContactDto, 'contactId'>,
    onChangeSuccess?: (value: ContactDto) => void
  ) => {
    onUpdate({
      contactId,
      ...values
    })
      .unwrap()
      .then((rs) => {
        message.systemSuccess(rs.message);
        onChangeSuccess?.(rs.data);
      });
  };

  return {
    onUpdateContactHandle,
    isLoading
  };
}
